import React, { useContext } from 'react'
import { Row, Col, Card, Table } from 'react-bootstrap'
import { useRoleDataAccesses } from 'api/hooks/use-role-data-accesses'
import TableLoading from 'shared/tables/table-loading'
import MutedText from 'shared/forms/muted-text'
import AccessToggle from 'duties/data-accesses/tabs/AccessToggle'
import { mapAccessType } from '../data-accesses/helper'
import UserContext from 'context/user-context'

function DataAccessTab({ roleId }) {
  const { municipality } = useContext(UserContext)
  const defaultParams = {
    page: 1,
    perPage: 25,
    role_id: roleId,
    hideNoAccess: true
  }

  const [params, setParams] = React.useState(defaultParams)

  const { isLoading, isSuccess, data } = useRoleDataAccesses({
    params
  })

  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm={'auto'}>
                <div className="text-info">Data Access</div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <AccessToggle params={params} setParams={setParams} />
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            {/* TODO: Consolidate to a single Users (Employees) Table */}
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Access</th>
                  <th>Access Type</th>
                  <th>Program</th>
                  <th>Start</th>
                  <th>End</th>
                </tr>
              </thead>

              <tbody>
                {isLoading && <TableLoading columns={1} />}
                {isSuccess &&
                  data.map((a) => (
                    <tr key={`role-row-${a.id}`}>
                      <td>
                        <a
                          href={`/data-access/${a?.data_access?.id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {a?.data_access?.name}{' '}
                        </a>
                        <br />
                        <MutedText>
                          {a?.data_access?.top_module_name}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.no_access ? 'No Access' : 'Access'}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {mapAccessType(municipality, a?.access_type)}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.program_name || a.program_id}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.start1}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.end1}
                        </MutedText>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default DataAccessTab
